import * as React from 'react';
import { AddonContext, CellContext } from '../generics';
import { ROWS } from './cell-split';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var ProductTableAddonAccordion = {
  body: function body(_ref) {
    var children = _ref.children;

    var _React$useContext = React.useContext(CellContext),
        gridColumnSpan = _React$useContext.gridColumnSpan;

    return _jsx(AddonContext.Provider, {
      value: {
        inAddon: 'accordion',
        order: 100,
        extraRules: {
          borderTop: '1px solid',
          paddingTop: 'sm',
          marginTop: 'xs',
          marginBottom: -6,
          variant: 'compounds.product-table.accordion.main'
        }
      },
      children: _jsx(CellContext.Provider, {
        value: {
          gridRowStart: ROWS + 7,
          gridRowSpan: 1,
          gridColumnStart: 1,
          gridColumnSpan: gridColumnSpan
        },
        children: children
      })
    });
  }
};
export default ProductTableAddonAccordion;
//# sourceMappingURL=addon-accordion.js.map